import { ISeguimientoList } from './../../../interfaces/shared/seguimiento-reqid';
import { IAbmBuscador } from './../../../interfaces/pages/abm/abm-buscador.interface';
import { Ipermission } from './../../../interfaces/shared/permission.interface';
import { IMenuData } from './../../../interfaces/shared/menu-home.interface';
import { User } from 'src/app/entities/shared/User';
import { Injectable } from "@angular/core";
import { Country, Icountry } from "../../../entities/shared/Country";
import { BehaviorSubject, Observable } from "rxjs";
import { Menu } from "../../../entities/shared/Menu";
import { EstructuraDinamicaHeader } from "../../../entities/shared/EstructuraDinamicaHeader";
import { EstructuraDinamicaField } from "../../../entities/shared/EstructuraDinamicaField";
import { Persona } from 'src/app/entities/shared/Persona';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  // Configuración GPC centralizada (antes estaba en environment)
  public readonly GPC_CONFIG = {
    env: {
      interno: 'DM',
      vip: 'VIP'
    },
    config: {
      default: 'DEFAULT',
    }
  };

  private readonly _regionSeleccionada$: BehaviorSubject<Country> = new BehaviorSubject(null);
  private readonly _menuApp$: BehaviorSubject<IMenuData | null> = new BehaviorSubject(null);
  private readonly _personaSelect$: BehaviorSubject<Persona | null> = new BehaviorSubject(null);
  private readonly _menuSelect$: BehaviorSubject<Menu | null> = new BehaviorSubject(null);
  private readonly columnsFilter$: BehaviorSubject<any | null> = new BehaviorSubject(null);
  private readonly columnsFilter2$: BehaviorSubject<any | null> = new BehaviorSubject(null);
  private readonly niveles$: BehaviorSubject<string[] | null> = new BehaviorSubject(null);
  private readonly _backToConfigSelection$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private readonly _breadcrumbUpdate$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private stateFilter = new BehaviorSubject<any | null>(null);
  currentStateFilter = this.stateFilter.asObservable();
  private _dataLogin: User;
  private _dataCountries: Icountry[];
  private _countryString: string;
  private _dataMenu: Menu[];
  private _dataSourceSelected: Menu;
  private _estructuraDinamicaHeader: EstructuraDinamicaHeader;
  private _estructuraDinamicaField: EstructuraDinamicaField[];
  private _dataFuenteBackup: any;
  private _dataPersonaDni: string;
  private _dataPersonaDniHash: string;
  private _matchkeySelected: string;
  private _observationListMatchkey: string;
  private _permission: Ipermission;
  private _isVip: boolean = false;
  private _isLoginRds: boolean = false;
  private _matrizArray: string[];
  private _primarykeyRds: string;
  private _primaryKeyConfig: any;
  private readonly _primaryKeyFieldRDSSubject = new BehaviorSubject<string>("");
  private _primaryKeyFieldRDS: string = "";
  private _dataview: any;
  private _timerOidc: string;
  private _timerSpinner: string;
  private _altaEntidadDocumento: string;
  private _keyingNamesData: any = null;
  private _manualVariants: any;
  private _dataBuscador: IAbmBuscador;
  private _ultAporteFh: number;
  private _menuConfig: IMenuData[];
  private setDataMatchKey: any;
  private domainMatchKey: any;
  // Matchkey completa armada desde el modal de busqueda avanzada.
  // Cuando esta seteada, getIdHash la usa tal cual y no prepone nada.
  private _fullMatchKeyAdvanced: string = '';
  private _isExternoRDS: boolean = false;
  private _selectedGfdConfig: string = 'Default';
  private _hasMultipleGfdConfigs: boolean = false;
  private _preSelectedDomainForSearch: string = '';
  private _selectedRdsConfig: string = '';
  private _fuentesViewMode: 'grid' | 'list' = 'grid';
  private _urlFuenteSelected: string = '';

  public selectDirty: { [key: string]: boolean };
  public dateBackup: { [key: string]: any };
  public esAltaEntidades: boolean = false;
  public bloqueoNominativo: boolean = false;
  public nombreNominativo: string = "";
  public filters;
  public sourcePrevius: string = '';
  public bkpSoftDeleteList: ISeguimientoList[];
  public listBreadcrumb = [];
  public pageSize: number | null = null;
  public esInternoRDS: boolean = false;
  public dataview: any = {};
  public valorprimaryKeyRDS: string = "";
  public sourceCreate: boolean = false;
  // guarda la lista de documentos traidas en el buscador
  public documentList: any = "";
  public cambiosGFD: any;
  public comment: string = "";
  public loginInit: any;
  public configInit: any;
  public universalSupplier;
  public supliersInformation;
  public subdomainPurp:string = "";
  public keyUpdates:Array<string> = [];

  public fields = null;

  // SETTERS
  set setRegionSeleccionada(country: Country) {
    const currentCountry = this._regionSeleccionada$.getValue();
    const currentCountryCode = currentCountry?.getCode();
    const newCountryCode = country?.getCode();

    // Solo limpiar si el código de país realmente cambió
    if (currentCountryCode !== newCountryCode) {
      // Limpiar el menú anterior al cambiar de país
      this._dataMenu = [];
      // Limpiar banderas de RDS al cambiar de país
      this.esInternoRDS = false;
      this.subdomainPurp = "";
      // Limpiar la fuente/estructura seleccionada del país anterior. Si no se limpia,
      // FuenteDinamicaComponent puede llamar a /schema/{nuevoPais}/{subDomainDelPaisViejo}
      // mientras el nuevo dataMenu todavía no matcheó la fuente actual.
      this._dataSourceSelected = null;
      this._estructuraDinamicaHeader = undefined;
      this._estructuraDinamicaField = undefined;
      this._selectedGfdConfig = 'Default';
      this._selectedRdsConfig = '';
      this._urlFuenteSelected = '';
      console.log('[LocalStorage] País cambiado de', currentCountryCode, 'a', newCountryCode, '- menú, fuente seleccionada y banderas RDS limpiados');

      this.setPermissionCountry = this.filterPermissionCountry(country.getCode());
      this._regionSeleccionada$.next(country);
    } else {
      // Actualizar el objeto Country pero sin limpiar nada
      console.log('[LocalStorage] Mismo país (', newCountryCode, '), actualizando objeto sin limpiar menú');
      this.setPermissionCountry = this.filterPermissionCountry(country.getCode());
      this._regionSeleccionada$.next(country);
    }
  }

  set setDataLogin(data: User) { this._dataLogin = data; }
  set setDataCountries(data: Icountry[]) { this._dataCountries = data; }
  set setCountryString(countryString: string) { this._countryString = countryString; }
  set setDataMenu(data: Menu[]) { this._dataMenu = data; }
  set setDataSourceSelected(data: Menu) { this._dataSourceSelected = data; }
  set setMenuSelected(data: Menu) {
    // Limpiar subdomainPurp al cambiar de menú para evitar que persista el valor de PURP
    this.subdomainPurp = "";
    this._menuSelect$.next(data);
  }
  set setEstructuraDinamicaHeader(data: EstructuraDinamicaHeader) { this._estructuraDinamicaHeader = data; }
  set setEstructuraDinamicaField(data: EstructuraDinamicaField[]) { this._estructuraDinamicaField = data; }
  set setDataFuenteBackup(data: any) { this._dataFuenteBackup = data; }
  set setPersonaSelected(data: Persona) { this._personaSelect$.next(data) }
  set setMenuConfig(data: IMenuData[]) { this._menuConfig = data; }
  set setMenuApp(data: IMenuData) { this._menuApp$.next(data) }
  set setPersonaSelectedDni(data: string) { this._dataPersonaDni = data; }
  set setPersonaSelectedDniHash(data: string) { this._dataPersonaDniHash = data; }
  set setMatchkeySelected(data: string) { this._matchkeySelected = data; }
  set setObservationListMatchkey(data: string) { this._observationListMatchkey = data; }
  set setPermissionCountry(permission: Ipermission) { this._permission = permission }
  set setIsVip(isVip: boolean) { this._isVip = isVip; }
  set setIsLoginRds(isLoginRds: boolean) { this._isLoginRds = isLoginRds; }
  set setMatrizArray(matrizArray: string[]) { this._matrizArray = matrizArray; }
  set setPrimarykeyRds(primarykeyRds: string) { this._primarykeyRds = primarykeyRds; }
  set setPrimaryKeyFieldRDS(primaryKeyFieldRDS: string) {
    this._primaryKeyFieldRDS = primaryKeyFieldRDS;
    this._primaryKeyFieldRDSSubject.next(primaryKeyFieldRDS); // Emitir el nuevo valor
  }
  set setDataview(dataview: any) { this._dataview = dataview; }
  set setTimerOidc(timerOidc: string) { this._timerOidc = timerOidc; }
  set setTimerSpinner(timerSpinner: string) { this._timerSpinner = timerSpinner; }
  set setManualVariants(data: any) { this._manualVariants = data; }
  set setBuscadorSelect(value: IAbmBuscador) { this._dataBuscador = value; }
  set setUltAporteFh(ultAporteFh: number) { this._ultAporteFh = ultAporteFh; }
  set setFilter(fields) { this.filters = fields; }
  set setSourcePrevius(source: string) { this.sourcePrevius = source; }
  set setListBreadcrumb(data) { this.listBreadcrumb = data; }
  set setColumnsFilter(data: any) { this.columnsFilter$.next(data); }
  set setColumnsFilter2(data: any) { this.columnsFilter2$.next(data); }
  set setPageSize(page: number) { this.pageSize = page }
  set setMatchKeyData(matchKeyData: any) { this.setDataMatchKey = matchKeyData }
  set setDomainMatchKey(domainMatchKey: any) { this.domainMatchKey = domainMatchKey }
  set setFullMatchKeyAdvanced(mk: string) { this._fullMatchKeyAdvanced = mk || ''; }
  set setNiveles(niveles: any) { this.niveles$.next(niveles) }
  set setIsExternoRDS(isExternoRDS: boolean) { this._isExternoRDS = isExternoRDS; }
  set setPrimaryKeyConfig(config: any) {this._primaryKeyConfig = config; }
  set setSelectedGfdConfig(config: string) { this._selectedGfdConfig = config; }
  set setHasMultipleGfdConfigs(hasMultiple: boolean) { this._hasMultipleGfdConfigs = hasMultiple; }
  set setSelectedRdsConfig(config: string) { this._selectedRdsConfig = config; }
  set setFuentesViewMode(mode: 'grid' | 'list') { this._fuentesViewMode = mode; }
  set setUrlFuenteSelected(url: string) { this._urlFuenteSelected = url; }
  set setAltaEntidadDocumento(documento: string) { this._altaEntidadDocumento = documento; }
                           // Fallback para alta de entidades - documento para keying
  set setKeyingNamesData(data: any) { this._keyingNamesData = data; }
                           // Datos de names (NAME_FULL, NAME_FIRST_NAME, etc.) del buscador para enriquecer el keying en ingestas

  // GETTERS
  get getNiveles(): any { return this.niveles$.getValue(); }
  get getDomainMatchKey(): any { return this.domainMatchKey; }
  get getMatchKeyData(): any { return this.setDataMatchKey; }
  get getFullMatchKeyAdvanced(): string { return this._fullMatchKeyAdvanced; }
  get getPageSize(): any { return this.pageSize; }
  get dataLogin(): User { return this._dataLogin; }
  get getListCountries(): Icountry[] { return this._dataCountries; }
  get getCountryString(): string { return this._countryString; }
  get regionSeleccionada(): Observable<Country> { return this._regionSeleccionada$.asObservable(); }
  get getRegionSeleccionada(): Country { return this._regionSeleccionada$.getValue(); }
  get dataMenu(): Menu[] { return this._dataMenu; }
  get getDataSourceSelected(): Menu { return this._dataSourceSelected; }                                             // Object con campos de fuente seleleccionada
  get getMenuSelectedObs(): Observable<Menu> { return this._menuSelect$.asObservable(); }                            // Object con campos de fuente seleleccionada (OBS)
  get dataEstructuraDinamicaHeader(): EstructuraDinamicaHeader { return this._estructuraDinamicaHeader; }
  get getEstructuraDinamicaField(): EstructuraDinamicaField[] { return this._estructuraDinamicaField; }
  get dataFuenteBackup() { return this._dataFuenteBackup; }                                                     // Object con datos como denominacion (Nombres), Documento, etc. Check EntityDinamica.ts
  get getPersonaSelected(): Persona { return this._personaSelect$.getValue(); }                                      // Object con datos HumanPersona.ts llenos
  get getPersonaSelectedObs(): Observable<Persona> { return this._personaSelect$.asObservable(); }                   // Object con datos HumanPersona.ts llenos (OBS)
  get getMenuConfig(): IMenuData[] { return this._menuConfig; }
  get getMenuAppObs(): Observable<IMenuData> { return this._menuApp$.asObservable(); }
  get getMenuApp(): IMenuData { return this._menuApp$.getValue(); }
  get getPersonaSelectedDni(): string { return this._dataPersonaDni; }                                               // ej: "11111111111", Nro documento, Cédula
  get getPersonaSelectedDniHash(): string { return this._dataPersonaDniHash; }                                       // Entitykey
  get getMatchkeySelected(): string { return this._matchkeySelected; }                                               // matchkey elegido para vista detalle
  get getObservationListMatchkey(): string { return this._observationListMatchkey; }                                 // entityKeyEncode (matchkey parcial) para obtener lista de observaciones
  get getPermissionCountry(): Ipermission { return this._permission; }
  get getIsVip(): boolean { return this._isVip; }
  get getIsLoginRds(): boolean { return this._isLoginRds; }
  get getMatrizArray(): string[] { return this._matrizArray; }
  get getPrimarykeyRds(): string { return this._primarykeyRds; }
  get getPrimaryKeyFieldRDS(): string { return this._primaryKeyFieldRDS; }

  /**
   * Determina si el menú actual es VIP basándose en múltiples criterios
   */
  isMenuVip(): boolean {
    // 1. Primero verificar la variable _isVip que se establece manualmente
    if (this._isVip) {
      return true;
    }

    // 2. Verificar el título del menú contra todos los títulos VIP del enum OptionAbmMenu
    const menuApp = this.getMenuApp;
    if (menuApp?.title) {
      // Incluir todos los valores VIP del enum OptionAbmMenu
      const vipTitles = [
        'Journaling VIP',        // OptionAbmMenu.FUENTES_VIP
        'Motor de búsqueda VIP', // OptionAbmMenu.SEARCH_VIP
        'Purposing VIP'          // OptionAbmMenu.PURPOSING_VIP
      ];

      if (vipTitles.some(title => menuApp.title === title)) {
        return true;
      }
    }

    return false;
  }

  /**
   * Determina si el menú actual es Interno basándose en múltiples criterios
   */
  isMenuInterno(): boolean {
    // 1. Verificar si es RDS (RDS es siempre interno)
    if (this.isMenuRds()) {
      return true;
    }

    // 2. Verificar el flag esInternoRDS
    if (this.esInternoRDS === true) {
      return true;
    }

    // 3. Verificar el título del menú contra todos los títulos internos del enum OptionAbmMenu
    const menuApp = this.getMenuApp;
    if (menuApp?.title) {
      // Incluir todos los valores internos (no VIP) del enum OptionAbmMenu
      const internoTitles = [
        'Journaling',        // OptionAbmMenu.FUENTES_INT
        'Motor de búsqueda', // OptionAbmMenu.SEARCH_INTERNO
        'Purposing'          // OptionAbmMenu.PURPOSING_INT
      ];

      // Verificar que sea interno (exactamente igual a uno de los títulos)
      if (internoTitles.some(title => menuApp.title === title)) {
        return true;
      }
    }

    return false;
  }

  /**
   * Determina si el menú actual es RDS basándose en múltiples criterios
   */
  isMenuRds(): boolean {
    // 1. Verificar el flag esInternoRDS
    if (this.esInternoRDS === true) {
      return true;
    }

    // 2. Verificar el flag _isLoginRds
    if (this._isLoginRds === true) {
      return true;
    }

    // 3. Verificar el título del menú
    const menuApp = this.getMenuApp;
    if (menuApp?.title) {
      // OptionAbmMenu.RDS = "RDS"
      if (menuApp.title === 'RDS') {
        return true;
      }
    }

    // 4. Verificar por domainJO del data source seleccionado (fuente RDS desde flujo interno) NO DEBERIRA IR
    // const domainJO = this._dataSourceSelected?.domainJO?.toUpperCase();
    // return !!(domainJO && (domainJO.startsWith('RDS_') || domainJO === 'RDS'));

    return false;
  }

  get getPrimaryKeyFieldRDS$(): Observable<string> { return this._primaryKeyFieldRDSSubject.asObservable(); }
  get getDataview(): any { return this._dataview; }
  get getTimerOidc(): string { return this._timerOidc; }
  get getTimerSpinner(): string { return this._timerSpinner; }
  get getManualVariants(): any { return this._manualVariants; }
  get getBuscadorSelect(): IAbmBuscador { return this._dataBuscador; }                                               // Object con campos del buscador elegido
  get getUltAporteFh(): number { return this._ultAporteFh; }
  get getColumnsFilter(): Observable<any> { return this.columnsFilter$.asObservable(); }
  get getColumnsFilter2(): Observable<any> { return this.columnsFilter2$.asObservable(); }
  // Getters para fallback de alta de entidades
  get getAltaEntidadDocumento(): string { return this._altaEntidadDocumento; }
  get getKeyingNamesData(): any { return this._keyingNamesData; }
  // GETTERS que no tienen SETTERS, si no que son calculados
  get getSourceCountrySelected(): string { return this._regionSeleccionada$?.getValue()?.getCode()?.toUpperCase(); } // ej: "AR"
  get getSourceDomainSelected(): string { return this._dataSourceSelected?.domainJO; }                               // ej: "AR_CONTACT_DATA"
  get getSourceSubDomainSelected(): string { return this._dataSourceSelected?.subDomainJO; }                         // ej: "EMAIL"
  get getFilter() { return this.filters; }
  get getSourcePrevius(): string { return this.sourcePrevius; }
  get getListBreadcrumb(): Array<any> { return this.listBreadcrumb; }
  get getIsExternoRDS(): boolean { return this._isExternoRDS; }
  get getPrimaryKeyConfig(): any { return this._primaryKeyConfig; }
  get getSelectedGfdConfig(): string { return this._selectedGfdConfig; }
  get getBackToConfigSelectionObs(): Observable<boolean> { return this._backToConfigSelection$.asObservable(); }
  get getHasMultipleGfdConfigs(): boolean { return this._hasMultipleGfdConfigs; }
  get getBreadcrumbUpdateObs(): Observable<boolean> { return this._breadcrumbUpdate$.asObservable(); }
  get getPreSelectedDomainForSearch(): string { return this._preSelectedDomainForSearch; }
  get getSelectedRdsConfig(): string { return this._selectedRdsConfig; }
  get getFuentesViewMode(): 'grid' | 'list' { return this._fuentesViewMode; }
  get getUrlFuenteSelected(): string { return this._urlFuenteSelected; }

  set setPreSelectedDomainForSearch(domain: string) { this._preSelectedDomainForSearch = domain; }

  filterPermissionCountry(codeCountry: string): Ipermission {
    const entitlements = this._dataLogin?.getEntitlement?.() || [];
    const permissionCountry: Ipermission[] = entitlements
      .filter(permission => permission.country.toLowerCase() === codeCountry.toLowerCase());

    if (!permissionCountry.length) {
      return null;
    }


    if (permissionCountry?.length > 1) {
      // En orden de relevancia los roles

      const niveles: string[] = JSON.parse(this.getNiveles.replace(/'/g, '"'));

      for (const nivel of niveles) {
        const find = permissionCountry.find(permission => permission.roles.toUpperCase() === nivel);
        if (find) {
          return find;
        }
      }
    } else {
      return permissionCountry[0];
    }
  }

  onFilterPreview(event) {
    // console.log('onFilterPreview', event);
    this.stateFilter.next(event);
  }

  onFilterPreviewReset() {
    this.stateFilter.next(null);
  }

  onBackToConfigSelection() {
    this._backToConfigSelection$.next(true);
    // Reset después de emitir para evitar disparar múltiples veces
    setTimeout(() => this._backToConfigSelection$.next(false), 100);
  }

  triggerBreadcrumbUpdate() {
    this._breadcrumbUpdate$.next(true);
    // Reset después de emitir
    setTimeout(() => this._breadcrumbUpdate$.next(false), 100);
  }

}
